<template>
  <b-container class="mt-5">
    <div v-if="showScreener">
          
      <div class="d-none d-md-block">    
      <b-row class="progress-row">
        <b-col>
          <ul class="progressbar">
            <li v-bind:class="{ active: current_step >= i }" v-for="i in max_step" :key="i">{{steps[i-1]}}</li>
          </ul>
        </b-col>
      </b-row>
      </div>
 
       <div class="d-block d-md-none">
          <div :class="['mobile-step',(current_step == i ? 'active' : null), (current_step > i ? 'completed' : null)]" v-for="i in max_step" :key="i">{{steps[i-1]}}</div>
      </div>
 

      <b-card v-if="current_step == 1" class="card-style">
        <h4 class="card-title" tabindex="0">Contact Information</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your contact information.</h4>
            <p tabindex="0">
              Please enter your contact information. We'll only use this information to contact you regarding enrolling in the First Steps 4K program.
            </p>
          </b-col>
        </b-row>
        <b-form @submit="contactInfoSubmit">
          <b-form-group
            label="Parent Or Guardian Name"
            label-sr-only
            label-for="name"
          >
            <label class="sr-only" for="name">Parent Or Guardian Name</label>
            <b-form-input
              id="name"
              v-model="name"
              placeholder="Parent or Guardian Name"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Email Address"
            label-sr-only
            label-for="email"
          >
          <label class="sr-only" for="email">Email Address</label>
            <b-form-input
              id="email"
              v-model="email"
              placeholder="Email Address"
              type="email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Cell Phone"
            label-sr-only
            label-for="phone"
          >
          <label class="sr-only" for="phone">Cell Phone</label>
            <b-form-input
              id="phone"
              v-model="phone"
              placeholder="Cell Phone"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group 
            label="How did you hear about First Steps 4K?"
            label-for="hear-radio"
          >
            <b-form-radio-group
              id="hear-radio"
              v-model="hearSelected"
              :options="hearOptions"
              name="hear-radio-options"
              required
              stacked
            >
            </b-form-radio-group>
            <b-form-input
              id="hearOther"
              v-model="hearOther"
              placeholder="Other"
              style="width:33%;"
            ></b-form-input>
          </b-form-group>
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card v-if="current_step == 2" class="card-style">
        <h4 class="card-title" tabindex="0">Address</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your home address.</h4>
            <p tabindex="0">
              Please select address from the dropdown below to proceed. 
            </p>
          </b-col>
        </b-row>
        <b-form-group
          label="Address"
          label-for="map"
          label-sr-only
        >
        <label class="sr-only" for="map">Address</label>
          <vue-google-autocomplete
          ref="addressTo"
          id="map"
          classname="form-control"
          placeholder="Start typing"
          v-on:placechanged="getAddressData"
          :rules="[rules.required]"
          :country="['us']"
          :enable-geolocation=true
          :value="getSavedAddress"
          style="margin-bottom:10px;"
          v-on:inputChange="addressInputChanged"
        >
        </vue-google-autocomplete>
        </b-form-group>
        <b-form-group
          label="Apartment Number"
          label-for="apartment"
          label-sr-only
        >
        <label class="sr-only" for="apartment">Apartment Number</label>
          <b-form-input
            id="apartment"
            v-model="apartment"
            placeholder="Apartment Number"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-button @click="onClickBack" class="float-left" pill variant="danger"
          >Back</b-button
        >
        <b-button
          @click="addressSubmit"
          class="float-right"
          type="submit"
          pill
          variant="primary"
          >Next</b-button
        >

        <div id="districtMap"></div>
      </b-card>
      <b-card
        v-if="current_step == 3"
        class="card-style"
      >
        <h4 class="card-title" tabindex="0">Child's Birthday</h4>
        <b-row align-v="start" class="text-left">
          <b-col>
            <h4 tabindex="0">Please enter your child's birthday.</h4>
          </b-col>
        </b-row>
        <b-form @submit="birthdaySubmit">
          <b-form-group
            label="Birthday Month"
            label-sr-only
          >
          <label class="sr-only">Birthday Month</label>
            <b-form-select
              v-model="birthdayMonth"
              :options="birthday_months"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="Birthday Day"
            label-sr-only
          >
          <label class="sr-only">Birthday Day</label>
            <b-form-select
              v-model="birthdayDay"
              :options="birthday_days"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="Birthday Year"
            label-sr-only
          >
          <label class="sr-only">Birthday Year</label>
            <b-form-select
              v-model="birthdayYear"
              :options="birthday_years"
              required
            ></b-form-select>
          </b-form-group>
          <p v-if="invalidBirthDate" class="error">
            You have entered an invalid birth date. Please enter the correct date.
          </p>
          <br />
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >Back</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card
        v-if="current_step == 4"
        class="card-style"
      >
        <h4 class="card-title" tabindex="0">Additional Criteria</h4>
        <h4 class="pb-4" tabindex="0">Select all that may apply:</h4>
        <b-form @submit="specialCircumstancesSubmit">
          <b-form-group
          >
            <b-form-checkbox-group
              id="criteria1"
              v-model="selectedCriteria"
              :options="criteria"
              stacked
              class="text-left"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >Back</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >Next</b-button
          >
        </b-form>
      </b-card>
      <b-card
          v-if="current_step == 5"
          class="card-style text-left"
      >
          <h4 class="card-title" tabindex="0">Income</h4>
          <b-card-text>
              Please enter your family's size including yourself, and your family's annual gross income (before taxes are taken out).
          </b-card-text>
          <b-form @submit="incomeSubmit">
              <b-form-group label="Persons in Household">
                  <b-form-select
                      v-model="peopleInHousehold"
                      :options="people_in_house_options"
                      required
                  >
                  </b-form-select>
              </b-form-group>
              <b-form-group label="Annual Income">
                  <CurrencyInput class="form-control" v-model="income" :options="currencyOptions" required></CurrencyInput>
                  <p v-if="invalidIncome" style="color:red;">Income is required.</p>
              </b-form-group>
              <b-button @click="onClickBack" class="float-left" pill variant="danger"
              >Back</b-button
              >
              <b-button class="float-right" type="submit" pill variant="primary"
              >Next</b-button
              >
          </b-form>
      </b-card>
    </div>
    <div v-else>
      <section style="background:white;" class="programs-services py-2" v-if="anyEligible && !categoryView && !programView">
        <h3 class="text-center pb-5">Based on the information you entered, your child may be eligible for the following program:</h3>
        <b-container>
          <b-row>
            <b-col class="mb-4" md="12" v-for="program in programs.filter(x => !x.Ineligible)" :key="program.ProgramId">
              <span class="program-name">{{program.Name}}</span>
              <p>{{program.ProgramShortDescription}}</p>
              <a class="button large-button purple-button float-right" href="/what-we-do/programs/first-steps-4k/apply">Apply Now</a>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section style="background:white;" class="programs-services py-2" v-else-if="!anyEligible">
        <h3 class="text-center pb-5">Based on the information you provided, you may not be eligible for First Steps 4K, however, you are still encouraged to apply.</h3>
        <a class="button large-button purple-button" href="/what-we-do/programs/first-steps-4k/apply">Apply Now</a>

        <h4 class="pt-5 pb-2">Other Early Childhood Resources</h4>
        <ul class="styled-list">
          <li><a href="https://first5sc.org/" target="_blank">First Five SC</a></li>
          <li><a href="https://abcquality.org/parent-resources/child-care-financial-assistance/" target="_blank">COVID-300 Child Care Assistance</a></li>
          <li><a href="/about-us/local-partnerships/" >Local First Steps Partnership Office</a></li>
          <li><a href="https://www.sc-ccrr.org/" target="_blank">SC Child Care Resource and Referral</a></li>
        </ul>

      </section>
    </div>
  </b-container>
</template>

<script>
import VueAutoComplete from "vue-google-autocomplete";
import CurrencyInput from "./CurrencyInput.vue"
export default {
  components: { "vue-google-autocomplete": VueAutoComplete, CurrencyInput },
  data() {
    return {
      programs: [],
      criteria: [],
      selectedCriteria: [],
      showScreener: true,
      anyEligible: false,
      isFourOrFive: false,
      invalidIncome: false,
      emailSent: "False",
      name: "",
      email: "",
      phone: "",
      hearSelected: "",
      hearOptions: [
        { text: 'Radio Ad', value: 'radio'},
        { text: 'AmeriCorps Service Member', value: 'americorps'},
        { text: 'Local Women, Infant, Children (WIC) Nutrition program office', value: 'wic'},    
        { text: "Video Advertisement", value:"video"},
        { text: "First Steps Local Partnership Office", value:"firststeps"},
        { text: "Palmetto Pre-K", value:"palmettoprek"},
        { text: "Postcard", value:"postcard"},
        { text: "Facebook", value:"facebook"},
        { text: "Instagram", value:"instagram"},
        { text: "Tik Tok", value:"tiktok"},
        { text: "Google Search", value:"googlesearch"},
        { text: "Friend/Neighbor/Colleague", value:"friend"},
        { text: "Childcare Center", value:"childcare"}, 
        { text: 'Other', value: 'other'}
      ],
      currencyOptions: {
        locale: undefined,
        currency: 'USD',
        currencyDisplay: 'symbol',
        valueRange: {undefined},
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        exportValueAsInteger: false,
        autoSign: true,
        useGrouping: true
      },
      hearOther: "",
      address: "",
      addressString: "",
      apartment: "",
      address_school_district: "",
      birthday: new Date(),
      current_step: 1,
      max_step: 5,
      steps: ["Contact Information","Home Address", "Child's Birthday", "Additional Criteria", "Income Eligibility"],
      birthdayMonth: null,
      birthdayYear: null,
      birthdayDay: null,
      invalidBirthDate: false,
      peopleInHousehold: 0,
      people_in_house_options: ["2", "3", "4", "5", "6", "7", "8"],
      incomeLimits: [0,0,30451,38443,46435,54427,62419,70411,78403],
      showIncome: false,
      income: 0.0,
      birthday_months: [
        { text: "Month", value: null },
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      birthday_days: [
        { text: "Day", value: null },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ],
      birthday_years: [
        { text: "Year", value: null },
        { text: "2010", value: "2010" },
        { text: "2011", value: "2011" },
        { text: "2012", value: "2012" },
        { text: "2013", value: "2013" },
        { text: "2014", value: "2014" },
        { text: "2015", value: "2015" },
        { text: "2016", value: "2016" },
        { text: "2017", value: "2017" },
        { text: "2018", value: "2018" },
        { text: "2019", value: "2019" },
        { text: "2020", value: "2020" },
        { text: "2021", value: "2021" },
        { text: "2022", value: "2022"},
        { text: "2023", value: "2023"}
      ],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      districts: {
          "abbeville":"Abbeville" ,
          "aiken":"Aiken" ,
          "allendale":"Allendale" ,
          "anderson-1":"Anderson 1" ,
          "anderson-2":"Anderson 2" ,
          "anderson-3":"Anderson 3" ,
          "anderson-4": "Anderson 4" ,
          "anderson-5": "Anderson 5" ,
          "bamberg-1":"Bamberg 1" ,
          "bamberg-2" : "Bamberg 2" ,
          "barnwell-19":"Barnwell 19" ,
          "barnwell-29":"Barnwell 29",
          "barnwell-45":"Barnwell 45",
          "beaufort":"Beaufort",
          "berkeley":"Berkeley",
          "calhoun":"Calhoun",
          "charleston":"Charleston",
          "cherokee":"Cherokee",
          "chester":"Chester",
          "chesterfield":"Chesterfield",
          "clarendon-1":"Clarendon 1",
          "clarendon-2":"Clarendon 2",
          "clarendon-3":"Clarendon 3",
          "colleton":"Colleton",
          "darlington":"Darlington",
          "dillon-3":"Dillon 3",
          "dillon-4":"Dillon 4",
          "dorchester-2":"Dorchester 2",
          "dorchester-4":"Dorchester 4",
          "edgefield":"Edgefield",
          "fairfield":"Fairfield",
          "florence-1":"Florence 1",
          "florence-2":"Florence 2",
          "florence-3":"Florence 3",
          "florence-4":"Florence 4",
          "florence-5":"Florence 5",
          "georgetown":"Georgetown",
          "greenville":"Greenville",
          "greenwood-50":"Greenwood 50",
          "greenwood-51":"Greenwood 51",
          "greenwood-52":"Greenwood 52",
          "hampton-1":"Hampton 1",
          "hampton-2":"Hampton 2",
          "horry":"Horry",
          "jasper":"Jasper",
          "kershaw":"Kershaw",
          "lancaster":"Lancaster",
          "laurens-55":"Laurens 55",
          "laurens-56":"Laurens 56",
          "lee":"Lee",
          "lexington-1":"Lexington 1",
          "lexington-2":"Lexington 2",
          "lexington-3":"Lexington 3",
          "lexington-4":"Lexington 4",
          "lexingtonrichland-5":"Lex-Rich 5",
          "marion":"Marion",
          "marlboro":"Marlboro",
          "mccormick":"McCormick",
          "newberry":"Newberry",
          "oconee":"Oconee",
          "orangeburg":"Orangeburg",
          "pickens":"Pickens",
          "richland-1":"Richland 1",
          "richland-2":"Richland 2",
          "saluda":"Saluda",
          "spartanburg-1":"Spartanburg 1",
          "spartanburg-2":"Spartanburg 2",
          "spartanburg-3":"Spartanburg 3",
          "spartanburg-4":"Spartanburg 4",
          "spartanburg-5":"Spartanburg 5",
          "spartanburg-6":"Spartanburg 6",
          "spartanburg-7":"Spartanburg 7",
          "sumter":"Sumter",
          "union":"Union",
          "williamsburg": "Williamsburg",
          "york-1":"York 1",
          "york-2":"York 2",
          "york-3":"York 3",
          "york-4":"York 4"
        }
    };
  },
  mounted: function () {
    

    if(localStorage.getItem("name") != null){
      this.name = localStorage.getItem("name");
    }

    if(localStorage.getItem("email") != null){
      this.email = localStorage.getItem("email");
    }

    if(localStorage.getItem("hearSelected") != null){
      this.hearSelected = localStorage.getItem("hearSelected");
    }

    if(localStorage.getItem("hearOther") != null){
      this.hearOther = localStorage.getItem("hearOther");
    }

    if(localStorage.getItem("phone") != null){
      this.phone = localStorage.getItem("phone");
    }

    if(localStorage.getItem("address") != null){
          this.address = JSON.parse(localStorage.getItem("address"));
    }

    if(localStorage.getItem("apartment") != null){
      this.apartment = localStorage.getItem("apartment");
    }

    if(localStorage.getItem("birthdayDay") != null){
      this.birthdayDay = localStorage.getItem("birthdayDay");
    }

    if(localStorage.getItem("birthdayMonth") != null){
      this.birthdayMonth = localStorage.getItem("birthdayMonth");
    }

    if(localStorage.getItem("birthdayYear") != null){
      this.birthdayYear = localStorage.getItem("birthdayYear");
    }

    if(localStorage.getItem("isFourOrFive") != null){
      this.isFourOrFive = localStorage.getItem("isFourOrFive");
    }

    if(localStorage.getItem("selectedCriteria") != null){
      this.selectedCriteria = JSON.parse(localStorage.getItem("selectedCriteria"));
    }

    if(localStorage.getItem("peopleInHousehold") != null){
      this.peopleInHousehold = JSON.parse(localStorage.getItem("peopleInHousehold"));
    }

    if(localStorage.getItem("income") != null){
      this.income = JSON.parse(localStorage.getItem("income"));
    }
    else{
      this.income = null;
    }

    fetch("https://first5sc.org/umbraco/api/programs/getcriteriabyprogram?id=2651")
      .then((response) => response.json())
      .then((data) => (this.criteria = data.reverse()));

    fetch("https://first5sc.org/umbraco/api/programs/getallprograms")
      .then((response) => response.json())
      .then((data) => (this.programs = data.filter(x => x.ProgramId == "2651")));

  },
  computed: {
    progress: function () {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    getSavedAddress: function(){
        //Retrieving address from local storage, refs only works when item is displayed;

        if(this.address){
          var addressString = this.address.street_number + ' ' + this.address.route + ', ' + this.address.locality + ', ' + this.address.administrative_area_level_1 + ' ' + this.address.postal_code;
          return addressString;
        }
        

        return '';
    }
  },
  methods: {
    contactInfoSubmit(event) {
      event.preventDefault();
      localStorage.setItem("email", this.email);
      localStorage.setItem("name", this.name);
      localStorage.setItem("phone", this.phone);
      localStorage.setItem("hearSelected", this.hearSelected);
      localStorage.setItem("hearOther", this.hearOther);
      

      

      this.postLead();
      this.$announcer.polite("Contact Information Submitted. New Content Loaded'");
      window.scrollTo(0,0);
      this.current_step++;
    },
    birthdaySubmit(event) {
      event.preventDefault();
      this.invalidBirthDate = false;
      var birthdayDayNew = this.birthdayDay;
      if (this.birthdayDay.length < 2) {
        birthdayDayNew = "0" + this.birthdayDay;
      }
      var birthdayString =
        this.birthdayYear +
        "-" +
        this.birthdayMonth +
        "-" +
        birthdayDayNew +
        "T00:00:00.000Z";
      var birthday = Date.parse(birthdayString);

      //check if valid date
      if (isNaN(birthday)) {
        this.invalidBirthDate = true;
        return false;
      }

      birthday = new Date(birthdayString);

      if (birthday.getUTCMonth() != this.birthdayMonth - 1) {
        this.invalidBirthDate = true;
        return false;
      }

      this.birthday = birthday;
      localStorage.setItem("birthdayMonth", this.birthdayMonth);
      localStorage.setItem("birthdayDay", this.birthdayDay);
      localStorage.setItem("birthdayYear", this.birthdayYear);
      this.checkEligibilityBirthday();
      window.scrollTo(0,0);
      this.$announcer.polite('Birthday Submitted. New Content Loaded');
      this.current_step++;
    },
    addressSubmit: function (event) {
      event.preventDefault();
      if (this.address) {
        var that = this;
        var map = new window.google.maps.Map(
          document.getElementById("districtMap"),
          {
            zoom: 6,
            center: { lat: 34, lng: -81 },
          }
        );
        map.data.loadGeoJson(
          "/dist/sc_school_districts.json",
          {},
          function (features) {
            var found = false;
            for (var i = 0; i < features.length; i++) {
              var feature = features[i];
              var gaGeom = feature.getGeometry();
              var poly = new window.google.maps.Polygon({
                paths: gaGeom.getAt(0).getArray(),
                map: map,
                clickable: false,
              });
              var point = new window.google.maps.LatLng(
                that.address.latitude,
                that.address.longitude
              );
              var inside = window.google.maps.geometry.poly.containsLocation(
                point,
                poly
              );

              if (inside) {
                that.address_school_district = feature.getProperty("slug");
                found = true;
                break;
              }
            }

            if (found) {
              window.scrollTo(0, 0);
              that.checkEligibilityLocation();
              

              if (that.address) {
                that.addressString = that.address.street_number + ' ' + that.address.route + ', ' + that.address.locality + ', ' + that.address.administrative_area_level_1 + ' ' + that.address.postal_code;
              }
              localStorage.setItem("address",JSON.stringify(that.address));
              localStorage.setItem("apartment", that.apartment);

              that.postLead();

              window.scrollTo(0,0);
              that.$announcer.polite('Address Information Submitted. New Content Loaded');
              that.current_step++;
            }
          }
        );
      } 
      else {
        return false;
      }
    },
    onClickBack: function () {
      window.scrollTo(0,0);
      this.current_step--;
    },
    getAddressData(addressData, placeResultData, id) {
      console.log(id, placeResultData);
      this.address = addressData;
    },
    addressInputChanged: function(){
      this.$announcer.polite("Please select an address using the arrow keys");
    },
    specialCircumstancesSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("selectedCriteria", JSON.stringify(this.selectedCriteria));
        window.scrollTo(0,0);

        if(this.selectedCriteria.length > 0){
          this.checkEligibilitySpecial();
          this.goToResults();
          this.showScreener = false;
        }
        else{
          this.current_step++;
        }
        
    },
    incomeSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("peopleInHousehold", JSON.stringify(this.peopleInHousehold));
        localStorage.setItem("income", JSON.stringify(this.income));
        window.scrollTo(0,0);
        this.checkEligibilityIncome();
        this.checkEligibilitySpecial();
        this.goToResults();
        this.showScreener = false;
        
        
    },
    checkEligibilityBirthday: function(){
        //check birthdays
        var that = this;

        var today = new Date();
        var isPrenatal = false;
        if(that.birthday > today){
          isPrenatal = true;
        }

        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleAge = false;
            var dateToCheck = new Date(that.programs[i].Age.AgeOfDate);
            var minAge = that.programs[i].Age.MinimumAge;
            var maxAge = that.programs[i].Age.MaximumAge;
            var age = this.ageOnDate(that.birthday, dateToCheck);
            if(!isPrenatal){
              if(minAge <= age && age <= maxAge){
                  that.programs[i].Ineligible = false;
              }
              else{
                  that.programs[i].IneligibleAge = true;
              }
            }
            else{
              if(that.programs[i].Age.IncludesPrenatal){
                that.programs[i].Ineligible = false;
              }
              else{
                that.programs[i].IneligibleAge = true;
              }
            }
            
        }

        //check if they are 4 or 5
        var checkAge = this.ageOnDate(that.birthday, today);
        if(checkAge == 4 || checkAge == 5){
          that.isFourOrFive = true;
        }
        else{
          that.isFourOrFive = false;
        }
        localStorage.setItem("isFourOrFive", that.isFourOrFive);
        
    },
    ageOnDate: function(birthday, dateToCheck){
        var checkDate = new Date(dateToCheck);
        var birthDate = new Date(birthday);
        var age = checkDate.getFullYear() - birthDate.getFullYear();
        var m = checkDate.getMonth() - birthDate.getMonth();
        age = age * 12 + m;
        return age;
    },
    checkEligibilityLocation: function(){
        var that = this;
        if(that.address){
          var county = that.address.administrative_area_level_2;
          var schoolDistrict = null;
          if(that.address_school_district){
            schoolDistrict = that.districts[that.address_school_district];
          }
          for(var i = 0; i < that.programs.length; i++){
            that.programs[i].CountyIneligible = false;
            that.programs[i].SchoolDistrictIneligible = false;
            if(county){
              if(that.programs[i].Counties && that.programs[i].Counties.length > 0){
                var matchingCounties = that.programs[i].Counties.filter(x => x == county);
                if(matchingCounties.length == 0){
                  that.programs[i].CountyIneligible = true;
                }
              }
            }
            if(schoolDistrict){
              if(that.programs[i].Districts && that.programs[i].Districts.length > 0){
                var matchingDistricts = that.programs[i].Districts.filter(x => x == schoolDistrict);
                if(matchingDistricts.length == 0){
                  that.programs[i].SchoolDistrictIneligible = true;
                }
              }
            }

          }
          
        }
    },
    checkEligibilitySpecial: function(){
        var that = this;
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleSpecial = false;
            that.programs[i].OverrideIncome = false;
            var totalReq = 0;

            if(that.programs[i].IncomeAsRequired){      
              if(that.programs[i].IneligibleIncome){
                that.programs[i].IneligibleIncome = false;
              }
              else{
                totalReq++;
              }
            }

            for(var j = 0; j < that.programs[i].Criteria.length; j++){
                var criteriaId = that.programs[i].Criteria[j].CriteriaId;
                var criteriaType = that.programs[i].Criteria[j].Type;
                if(that.selectedCriteria.includes(criteriaId)){
                    if(criteriaType == "Override Income"){
                        that.programs[i].OverrideIncome = true;
                    }
                    else if(criteriaType == "Required"){
                      totalReq++;
                    }
                }
                else {
                    if(criteriaType == "Required" && that.programs[i].MinimumRequired == 0){
                        if(that.programs[i].ProgramId == 1088){
                          console.log('missing id: ' + criteriaId);
                        }
                        that.programs[i].IneligibleSpecial = true;
                    }

                    if(criteriaType == "Absolute"){
                      that.programs[i].IneligibleSpecial = true;
                    }
                }
            }

            if(that.programs[i].MinimumRequired > 0 && that.programs[i].MinimumRequired > totalReq){
              if(that.programs[i].ProgramId == 1088){
                console.log("head start ineligible special. min req: " + that.programs[i].MinimumRequired + " totalReq hit: " + totalReq);
              }
              that.programs[i].IneligibleSpecial = true;
            }
        }
    },
    checkEligibilityIncome: function(){
        var that = this;
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleIncome = false;
            var income = that.programs[i].Incomes.filter(function(j){
                return j.PeopleInHousehold == that.peopleInHousehold;
            });
            if(income.length > 0){
              if(that.income > income[0].MaximumIncome){
                  that.programs[i].IneligibleIncome = true;
              }
            }
            
        }
    },
    goToResults: function(){
        //Final eligibilty check before showing the results
        var that = this;

        console.log(that.programs);
        console.log(that.selectedCriteria);

        for(var i = 0; i < that.programs.length; i++){
            if(that.programs[i].CountyIneligible || that.programs[i].SchoolDistrictIneligible || that.programs[i].IneligibleAge || 
                          that.programs[i].IneligibleSpecial || (that.programs[i].IneligibleIncome && !that.programs[i].OverrideIncome)){
                that.programs[i].Ineligible = true;
            }
            else{
              that.anyEligible = true;
            }
        }

        that.postLead();
        localStorage.setItem("programs", JSON.stringify(that.programs));
        localStorage.setItem("anyEligible", that.anyEligible);
        this.$announcer.polite('Application submitted. Your results loaded.');
    },
    postLead: function(){

      var combinedAddress = this.addressString;
      if(this.apartment){
        combinedAddress += ", Apartment: " + this.apartment;
      }
      var lead = {
        "Name": this.name,
        "Email": this.email,
        "Phone": this.phone,
        "Address": combinedAddress,
        "ReferralType": this.hearSelected,
        "ReferralNote": this.hearOther,
        "Eligible": this.anyEligible,
      };
      try{
        fetch('https://admin.free4ksc.org/api/LeadsAPI/',
        {
          method: 'POST',
          headers: 
            {
              'Content-Type': 'application/json'
            },
          body: JSON.stringify(lead)
        });
      } catch{
        console.log('error saving lead');
      }
    }
  },
};
</script>
